import Axios from "axios";
import {
  SET_BONUS_PROCESS_REPORT_LIST,
  UNSET_BONUS_PROCESS_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getBonusProcessReport,
} from "@/store/api";

const state = {
  getBonusProcessReport: [],
};

const getters = {
  getBonusProcessReport(state) {
    return state.getBonusProcessReport;
  },
};

const mutations = {
  [SET_BONUS_PROCESS_REPORT_LIST](state, data) {
    state.getBonusProcessReport = data;
  },
  [UNSET_BONUS_PROCESS_REPORT_LIST](state) {
    state.getBonusProcessReport = [];
  },
};

const actions = {
  getBonusProcessReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getBonusProcessReport}`, { params: data })
        .then((response) => {
          commit(SET_BONUS_PROCESS_REPORT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_BONUS_PROCESS_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

